import React, { Fragment } from 'react';
import { qantasHotels } from 'roo-ui/logos';
import { rem } from 'polished';
import { Container, Flex, Link } from 'roo-ui/components';
import styled from '@emotion/styled';
import NavigationLinks from './NavigationLinks';
import SimplicityHeader from 'components/SimplicityHeader';
import { AuthenticationButton } from 'components/User';
import { QCOM_LANDING_PAGE_URL } from 'config';
import LoginTooltip from 'components/LoginTooltip';

const Logo = styled.img`
  display: inline-flex;
  width: ${rem('186px')};
`;

const HeaderInner = styled(Flex)`
  justify-content: space-between;
  align-items: flex-end;

  @media print {
    display: none;
  }
`;

const HeaderDesktop = () => (
  <Fragment>
    <SimplicityHeader />
    <Container pr={4}>
      <HeaderInner>
        <Link href={QCOM_LANDING_PAGE_URL} mr={4} mb={2} p={1} data-testid="qh-logo-link">
          <Logo src={qantasHotels} alt="Qantas" role="img" aria-label="Qantas Logo" />
        </Link>
        <Flex data-print-style="hidden" mb={-2}>
          <LoginTooltip isDesktop />
          <AuthenticationButton />
        </Flex>
      </HeaderInner>
    </Container>
    <NavigationLinks />
  </Fragment>
);

export default HeaderDesktop;
